import styled from "styled-components/macro"
import { DialogContent } from "@material-ui/core"
import { MultilineInput } from "@humanpredictiveintelligence/myqvt-library"

export const Container = styled.div`
  display: flex;
  align-items: center; 
  gap: 12px;
`

export const Text = styled.p`
  font-size: 12px;
  white-space: pre-wrap;
`

export const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DemandInput = styled(MultilineInput)`
  .Field {
    width: 100%;
  }
`
